'use client';

import { forwardRef } from 'react';
import { EditorComponent } from './EditorComponent';
import type { ImperativeEditorRef } from './plugins/ImperativeRefPlugin';
import type { ComponentProps } from 'react';

type EditorComponentProps = ComponentProps<typeof EditorComponent>;

type CopilotComposerProps = Omit<EditorComponentProps, 'variant'>;

export const CopilotComposer = forwardRef<
  ImperativeEditorRef,
  CopilotComposerProps
>((props, ref) => {
  return <EditorComponent {...props} ref={ref} variant="copilot" />;
});

CopilotComposer.displayName = 'CopilotComposer';
